import { type BadgeConfig } from "@pimo/pimo-components";
import { getLocalizedMessage } from "@pimo/pimo-l10n";
import dayjs from "dayjs";
import {
  BffReport,
  COLORS,
  CONTRAST_TEXT_COLORS,
  ReportingDetails,
} from "vmd-types";
import { getReportingStatus } from "vmd-utils";

import { formatDate, formatDateTime } from "./format-date";

export function getProjectStatusBadge({
  currentReport,
  language,
  reportingCycle,
}: {
  currentReport?: BffReport;
  lastUpdatedAt?: string;
  reportingCycle?: ReportingDetails;
  language: string;
}): BadgeConfig {
  const completed = dayjs(
    currentReport?.project?._calculated?.completionDate
  ).isValid();

  const lastUpdatedAt = currentReport?.project?._calculated?.lastUpdatedAt;
  const lastUpdatedBy = currentReport?.project?._calculated?.lastUpdatedBy;
  const updateStatus =
    reportingCycle && reportingCycle.frequency && reportingCycle.unit
      ? getReportingStatus({
          endReportingDateInStringFormat: reportingCycle?.endReportingCycleDate,
          frequency: reportingCycle?.frequency,
          unit: reportingCycle?.unit,
          lastUpdatedDateInStringFormat:
            currentReport?.project?._calculated?.lastUpdatedAt,
        })
      : {
          color: COLORS[0],
          muiIcon: "SentimentSatisfied",
          status: getLocalizedMessage(language || "en", "updated") || "Updated",
          icon: "mood-smile.svg",
          contrastTextColor: CONTRAST_TEXT_COLORS[0],
        };

  const updateStatusBadge: BadgeConfig = {
    hoverText: updateStatus?.status
      ? `${updateStatus?.status} ${
          lastUpdatedAt
            ? `${
                getLocalizedMessage(language || "en", "asOf") || "as of"
              } ${formatDateTime(lastUpdatedAt, language)}`
            : ""
        }${
          lastUpdatedBy
            ? ` ${getLocalizedMessage(language || "en", "by") || "by"} ${lastUpdatedBy}`
            : ""
        }`
      : "N/A",
    label: completed
      ? `${
          getLocalizedMessage(language || "en", "completedOn") || "Completed On"
        } ${
          currentReport?.project?._calculated?.completionDate
            ? formatDate(
                currentReport.project._calculated.completionDate,
                language
              )
            : "N/A"
        }`
      : `${
          getLocalizedMessage(language || "en", "nextReportingBy") ||
          "Next Reporting by"
        } ${
          reportingCycle?.endReportingCycleDate
            ? formatDate(reportingCycle.endReportingCycleDate, language)
            : "N/A"
        }`,
    icon: !completed ? updateStatus.icon : undefined,
    muiIcon: completed ? "CheckCircleOutlined" : undefined,
    iconColor: completed
      ? CONTRAST_TEXT_COLORS[0]
      : updateStatus?.contrastTextColor,
    backgroundColor: completed ? COLORS[0] : updateStatus?.color,
    color: completed
      ? CONTRAST_TEXT_COLORS[0]
      : updateStatus?.contrastTextColor,
  };

  return updateStatusBadge;
}
